import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import { useNavigate } from 'react-router-dom';

const ViewBrandingImage = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [imagePath, setImagePath] = useState(null);

 
    const navigate = useNavigate();

   

    const formik = useFormik({
      
        initialValues: {
            id: '',
         
        },
        onSubmit: async (data) => {
           
        }
    });

    const getBrandImageById = async () => {
        setLoadingBtn(true);

        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const merchantId = user?.data?.merchantId;

        const response = await handleGetRequest(endPoints.getMerchantBrandingImageId(merchantId), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('merchantId', response?.data?.merchantId);

            setImagePath(response?.data?.imagePath || null); 
        }

        setLoadingBtn(false);
    };

    useEffect(() => {
        getBrandImageById();
    }, []);

    const handleClick = () => {
        navigate('/profile');
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Branding Image</h3>
            </div>
            <div className="col-12 md:col-6">
                <div className="mb-3">
                    <div className="field">
                        {imagePath ? (
                            <div className="col-12 md:col-12">
                                <img src={imagePath} alt="Branding" style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '8px' }} />
                            </div>
                        ) : (
                            <p className="text-center text-gray-500">No image available.</p>
                        )}
                    </div>
                </div>
            </div>

            <form onSubmit={formik.handleSubmit}>
       

                <div className="flex justify-content-center mt-4 gap-2">

                    <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120 }} onClick={handleClick} />
                </div>
            </form>
        </div>
    );
};

export default ViewBrandingImage;
